export default class HasuraAuthenticationError extends Error {
  constructor(message = `Can't authenticate on a graphql server!`) {
    super(message);
    this.name = 'HasuraAuthenticationError';
  }
}
